import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { D4CActions, Selectors } from '../store';
import { MetaComponent, BreadcrumbsComponent, PluginsComponent } from '.';
import { BannerComponent } from '@ca/ca-ng-core';

@Component({
  selector: 'ca-home',
  imports: [
    CommonModule,
    BannerComponent,
    PluginsComponent,
    MetaComponent,
    BreadcrumbsComponent
  ],
  template: `
    @if (page$ | async; as page) {
      @if (page.meta) {
        <d4c-meta [metaTags]="page.meta"></d4c-meta>
      }
      @if (role$ | async; as role) {
        <ca-banner [data]="page.banners[role]"></ca-banner>
        <d4c-breadcrumbs />
      } @else {
        <ca-banner [data]="page.banners.general"></ca-banner>
      }

      <d4c-plugins />
    }
  `,
})
export class HomeComponent implements OnInit, OnDestroy {
  private store = inject(Store);

  root$ = this.store.select(Selectors.selectCurrentRoute);
  params$ = this.store.select(Selectors.selectRouteParams);
  role$ = this.store.select(Selectors.selectUserRole);
  page$ = this.store.select(Selectors.selectPagesRoot);

  ngOnInit(): void { this.store.dispatch(D4CActions.LoadPage({ path: [] })); }
  ngOnDestroy(): void { }
}
